export default __webpack_public_path__ + "static/media/logohp.2782393f.png";